

export class ColorScheme {
    static readonly PointColors = [ 
        '#000000','#C00000', '#ED7D31', '#FFC000', '#00B050', '#00B0F0', '#2B22AA', '#7F00FF', '#964B00', '#808080', 
        '#BF8F00', '#FF8080', '#FFB66D', '#57FF7F', '#7979FF', '#FF8BFF', '#FFD03B', '#595959', '#548235', '#2F75B5', 
        '#7B760F', '#7030A0', '#820000', '#0000FF', '#1FBFB0', '#000099' 
    ]

    static pointColorForIndex( index : number ) {
        const colors = ColorScheme.PointColors
        index = Number(index)
        if ( index < 0 ) {
            index+=colors.length  
        }
        const color = colors[Math.abs(index%colors.length)]
        //console.log('color for index ' + index + ' = ' + color)
        return color
    }
}

